import { Box } from '@zillow/constellation-10';
import { css } from '@/styled-system/css';
import { FunctionComponentWithChildren } from 'src/utils/types';

/**
 * Stories implemented
 */
/* eslint-disable local-rules/require-storybook-documentation */

export const ZillowNavbarContentContainer: FunctionComponentWithChildren = ({ children }) => (
    <Box
        className={css({
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            alignItems: 'center',
            width: '100%',
            height: '100%',
        })}>
        {children}
    </Box>
);
